import React, {useEffect, useState} from 'react';

export const EnpsDistribution = ({enps}) => {
    const [detractors, setDetractors] = useState(null);
    const [passives, setPassives] = useState(null);
    const [promotors, setPromotors] = useState(null);

    useEffect(() => {
        if(enps){
            setDetractors(enps.detractors * 100 / enps.total);
            setPassives(enps.passives * 100 / enps.total);
            setPromotors(enps.promotors * 100 / enps.total)
        }
    }, [enps]);

    return (
        <div style={{paddingTop: 10, marginLeft: 10, marginRight: 10, display: 'flex', flexDirection: 'column', height: '100%'}}>
            <div style={{color: 'rgba(133, 133, 133, 1)', fontSize: 16, fontStyle: 'SFProText-Bold'}}>eNPS Distribution (%)</div>
            <div style={{display: 'flex', height: '65%', width: '100%', textAlign: 'center', marginTop: '5%'}}>
                <div style={{width: '33%', marginLeft: '0.5%', height: '100%'}}>
                    <div style={{flex: 1, height: '45%', color: 'rgba(133, 133, 133, 1)', fontSize: 12, fontStyle: 'SFProText-Regular'}}>
                        Detractors
                    </div>
                    <div style={{flex: 1, height: '55%'}}>
                        <span style={{color: '#FF5A5F', fontSize: 30, fontStyle: 'SFProText-Bold', fontWeight: 'bold'}}>{detractors}</span><span style={{color: '#FF5A5F', fontSize: 15, fontStyle: 'SFProText-Bold', fontWeight: 'bold'}}>%</span>
                    </div>
                </div>
                <div style={{width: '33%', marginLeft: '0.5%', height: '100%', borderLeftWidth: 1, borderLeftStyle: 'solid', borderLeftColor: 'rgba(133, 133, 133, 1)', borderRightWidth: 1, borderRightStyle: 'solid', borderRightColor: 'rgba(133, 133, 133, 1)'}}>
                    <div style={{flex: 1, height: '45%', color: 'rgba(133, 133, 133, 1)', fontSize: 12, fontStyle: 'SFProText-Regular'}}>
                        Passives
                    </div>
                    <div style={{flex: 1, height: '55%'}}>
                        <span style={{color: '#FCC65C', fontSize: 30, fontStyle: 'SFProText-Bold', fontWeight: 'bold'}}>{passives}</span><span style={{color: '#FCC65C', fontSize: 15, fontStyle: 'SFProText-Bold', fontWeight: 'bold'}}>%</span>
                    </div>
                </div>
                <div style={{width: '33%', marginLeft: '0.5%', height: '100%'}}>
                    <div style={{flex: 1, height: '45%', color: 'rgba(133, 133, 133, 1)', fontSize: 12, fontStyle: 'SFProText-Regular'}}>
                        Promotors
                    </div>
                    <div style={{flex: 1, height: '55%'}}>
                        <span style={{color: '#00CF8F', fontSize: 30, fontStyle: 'SFProText-Bold', fontWeight: 'bold'}}>{promotors}</span><span style={{color: '#00CF8F', fontSize: 15, fontStyle: 'SFProText-Bold', fontWeight: 'bold'}}>%</span>
                    </div>
                </div>
            </div>
        </div>
    )
}